import { useSelector } from "react-redux";
// import CaseLevelWorkQ from "./custom/CaseLevelWorkQ";
import GDQWorkQ from "./custom/GDQWorkQ";
import MedicalRecords from "./custom/MedicalRecords";
import PoliceReportWorkQ from "./custom/PoliceReportWorkQ";
// import SOSWorkQ from "./custom/SOSWorkQ";
// import SurgeryAFS from "./custom/SurgeryAFS";
// import SurgeryBFS from "./custom/SurgeryBFS";
// import SurgeryRFS from "./custom/SurgeryRFS";
// import UndeterminedWorkQ from "./custom/UndeterminedWorkQ";
// import VerificationWorkQ from "./custom/VerificationWorkQ";
import FollowUpQ from "./custom/FollowUpQ";
import FollowUpFinalQ from "./custom/FollowUpFinalQ";
import MismatchedDataWorkQ from "./custom/MismatchedDataWorkQ";
import InvalidFaxWorkQ from "./custom/InvalidFaxWorkQ";

export default function CustomWorkQs({slug, loading}) {

    const patientsList =  useSelector(state => state.filter.currentpagedata)
    const snapshot = useSelector(state => state.filter.snapshotData)
    return <>
        {slug == 'work-queues-global' && <GDQWorkQ loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList}/>}
        {slug == 'work-queues-medical-records' &&  <MedicalRecords loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />}
        {/* {slug == 'surgeries-rfs' &&  <SurgeryRFS loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />}
        {slug == 'surgeries-afs' &&  <SurgeryAFS loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />}
        {slug == 'surgeries-bfs' &&  <SurgeryBFS loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />} */}
        {/* {slug == 'verification' &&  <VerificationWorkQ loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />} */}
        {/* {slug == 'case-level' &&  <CaseLevelWorkQ loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />} */}
        {/* {slug == 'undetermined' &&  <UndeterminedWorkQ loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />} */}
        {/* {slug == 'sos' &&  <SOSWorkQ loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />} */}
        {slug == 'missed-appts-fu-front-desk' &&  <FollowUpQ loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />}
        {slug == 'missed-appts-fu-management' &&  <FollowUpFinalQ loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />}


        {slug == 'police-report' &&  <PoliceReportWorkQ loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />}

        {slug == 'drivers-license-mismatch' &&  <MismatchedDataWorkQ loading={loading} snapshot={snapshot} workqSlug={slug} patientsList={patientsList} />}

        {slug == 'invalid-fax-q' &&  <InvalidFaxWorkQ loading={loading} patientsList={patientsList} />}
    </>
}